<ng-container *ngIf="recordSelected==undefined || !recordSelected.id">
  <button type="button" *ngIf="showSearchButton" class="btn btn-sm btn-primary btn-block" (click)="explore()"><i class="fa fa-list mr-2"></i>Seleziona</button>
</ng-container>
<ng-container *ngIf="recordSelected!=undefined && recordSelected.id">
  <div class="input-group alert-primary" style="justify-content: space-between;">
    <h5 [class.trashed]="recordSelected['status']==2" class="text-truncate text-primary p-1 m-0" style="max-width:85%;"><b>{{recordSelected[fieldRender]}}</b></h5>
    <div class="input-group-append">
      <a type="button"  title="Seleziona" *ngIf="showSearchButton" class="btn btn-primary" (click)="edit()"><i class="fas fa-list"></i></a>
      <a type="button"  title="Visualizza / Modifica" *ngIf="showViewButton" class="btn btn-secondary" (click)="view()"><i class="fas fa-pencil-alt"></i></a>
      <a type="button"  title="Dissocia" *ngIf="showUnlinkButton" class="btn btn-primary" (click)="unlink()"><i class="fas fa-unlink"></i></a> 
    </div>
  </div>
</ng-container>

<datalist id="values">
    <ng-container *ngFor="let r of list">
      <option value="{{r[fieldRender]}}"></option>
    </ng-container>
    <option value="Aggiungi"></option>
</datalist>